import { createSlice } from "@reduxjs/toolkit";

const expenseSlice = createSlice({
    name: "expense",
    initialState: {
        expenses: [],
        expenseByProjectId:[]
    },
    reducers: {
        fetchExpenses: (state, action) => {
            state.expenses = action.payload
        },
        fetchExpensesByProjectIdReducer:(state, action)=>{
            state.expenseByProjectId= action.payload
        }
    }
})
export const { fetchExpenses, fetchExpensesByProjectIdReducer } = expenseSlice.actions
export default expenseSlice.reducer